export default __webpack_public_path__ + "locales/bg/ConnectDialog.json?hash=5d06d19c54bb3ac18598e7d228fd348f";